export enum OperacionCorporateLendingFields {
  CodPais = 'codPais',
  NombrePais = 'nombrePais',
  CodOperacionCorporateLendingEstado = 'codOperacionCorporateLendingEstado',
  DescOperacionCorporateLendingEstado = 'descOperacionCorporateLendingEstado',
  FechaEmision = 'fechaEmision',
  FechaVencimiento = 'fechaVencimiento',
  Observaciones = 'observaciones',
  FechaAlta = 'fechaAlta',
  IdUsuarioAlta = 'idUsuarioAlta',
  NombreUsuarioAlta = 'nombreUsuarioAlta',
  ApellidoUsuarioAlta = 'apellidoUsuarioAlta',
  MailUsuarioAlta = 'mailUsuarioAlta',
  EstadoFinalizado = 'estadoFinalizado',
  Envio = 'envio',
  IdMensaje = 'idMensaje',
  PermiteEditarOperacion = 'permiteEditarOperacion',
  PermiteEliminarOperacion = 'permiteEliminarOperacion',
  Detalle = 'detalle',
}

export enum OperacionCorporateLendingDetalleFields {
  IdOperacionCorporateLending = 'idOperacionCorporateLending',
  Deudor = 'deudor',
  Acreedor = 'acreedor',
  Moneda = 'moneda',
  Monto = 'monto',
  Destino = 'destino',
  PlazoDisponibilidad = 'plazoDisponibilidad',
  Plazo = 'plazo',
  Amortizacion = 'amortizacion',
  Comision = 'comision',
  Precancelacion = 'precancelacion',
  TasaInteres = 'tasaInteres',
  FrecuenciaInteres = 'frecuenciaInteres',
  FiadorAvalista = 'fiadorAvalista',
  Garantias = 'garantias',
  Pagare = 'pagare',
  Covenants = 'covenants',
  Ley = 'ley',
  FechaEjecucion = 'fechaEjecucion',
  FechaAlta = 'fechaAlta',
  IdUsuarioAlta = 'idUsuarioAlta',
  FechaUltMod = 'fechaUltMod',
  IdUsuarioUltMod = 'idUsuarioUltMod',
  Activo = 'activo',
  PermiteEditar = 'permiteEditar',
}

